import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Auth0Service } from '@geneplanet/ngx-auth0';
import { IntentStrategyService } from 'src/app/shared/services/intent/intent-strategy.service';

@Injectable({ providedIn: 'root' })
export class AccountsVerifiedGuard implements CanActivate, CanActivateChild {
  private readonly auth0 = inject(Auth0Service);
  private readonly intentStrategyService = inject(IntentStrategyService);

  canActivateChild(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> {
    return this.isActive(route);
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.isActive(route);
  }

  private isActive(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> {
    // Logic to skip onboarding steps - Questioner onboarding
    if (route.queryParams?.skip && !!JSON.parse(route.queryParams?.skip)) {
      return of(true);
    }

    return this.auth0.token$.pipe(
      switchMap((token) => {
        // token$ emits a JSON-encoded string (or null/undefined) at runtime,
        // even though it's typed as `unknown` upstream.
        const account = new JwtHelperService().decodeToken(
          JSON.parse((token as string) || '{}').idToken
        );

        if (!account) {
          return this.intentStrategyService.context.onUserNotExists();
        } else if (account?.email_verified) {
          return of(true);
        } else {
          // Redirect to verify screen
          return this.intentStrategyService.context.onNotValidatedEmail();
        }
      })
    );
  }
}
